import ConnectedWorkflowPanel from './WorkflowPanel';

export default ConnectedWorkflowPanel;
